/** User-facing copy for the finalise pay run modal. See docs/adr/0008. */
export const FINALISE_PAYRUN_COPY = {
  title: 'Finalise Pay Run',
  descriptionHeading: 'Finalising a pay run locks the pay run and prevents future edits.',
  descriptionBody:
    'Finalisation and payslip publishing happen immediately. Payslips will be sent to workers on the scheduled pay date and time.',
  finaliseExternalLabel: 'Finalise external pay run and publish payslips',
  finaliseExternalHint: 'Available to workers immediately',
  sendPayslipsLabel: 'Send payslips to workers at pay date and time',
  sendPayslipsHint: 'Notifications are sent on the pay date',
  submit: 'Finalise Pay Run',
  cancel: 'Cancel',
  successToast: 'Pay run finalised',
  finalisationRowLabel: 'Finalisation date',
  payDateRowLabel: 'Pay date',
} as const;

/** dayjs format for the read-only date rows shown in the modal, e.g. "12 Jun, 2026 at 3:00 PM". */
export const FINALISATION_DATE_FORMAT = 'D MMM, YYYY [at] h:mm A';
export const PAY_DATE_FORMAT = 'D MMM, YYYY [at] h:mm A';
